/* eslint-disable */
export default {
  logging: '正在记录…',
  logCall: '记录通话',
  editLog: '编辑记录',
  select: '选择记录',
  OnHold: '暂候',
  Ringing: '正在振铃',
  CallConnected: '呼叫已接通',
  unknownUser: '未知用户',
  unknownNumber: '匿名',
  unavailable: '不可用',
  viewDetails: '查看详细信息',
  conferenceCall: '电话会议',
  callerId: '主叫信息',
} as const;

// @key: @#@"logging"@#@ @source: @#@"Logging..."@#@
// @key: @#@"logCall"@#@ @source: @#@"Log Call"@#@
// @key: @#@"editLog"@#@ @source: @#@"Edit Log"@#@
// @key: @#@"select"@#@ @source: @#@"Select record"@#@
// @key: @#@"OnHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"Ringing"@#@ @source: @#@"Ringing"@#@
// @key: @#@"CallConnected"@#@ @source: @#@"Call Connected"@#@
// @key: @#@"unknownUser"@#@ @source: @#@"Unknown User"@#@
// @key: @#@"unknownNumber"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"unavailable"@#@ @source: @#@"Unavailable"@#@
// @key: @#@"viewDetails"@#@ @source: @#@"View Details"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
// @key: @#@"callerId"@#@ @source: @#@"Caller ID"@#@
